<template>
  <landing-page
    label="factSheet.breastCancerTitle"
    labelColor="#603813"
    descColor="#603813"
    :eggImgObj="{ componentName: 'factsheet', imgName: 'breastCancerLandingImage', imgFormat: 'png' }"
    :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }"
  />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div v-html="t('factSheet.breastCancerDesc')" class="space-y-12" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.whoHaveHigherChangeOfHavingBreastCancer") }}</div>
      <div v-html="t('factSheet.highRiskFactors')" class="mb-5" />
      <ul class="space-y-5 bullet-big">
        <template v-for="(item, index) in factSheetStore.breastCancerHighRiskFactorsList" :key="'breastCancerHighRiskFactors' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.causeOfBreastCancer") }}</div>
      <div v-html="t('factSheet.causeOfBreastCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.symptomsOfBreastCancer") }}</div>
      <div v-html="t('factSheet.symptomsOfBreastCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.breast") }}</div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.breastCancerBreastSymptomsList" :key="'breastCancerBreastList' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.nipple") }}</div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.breastCancerNippleSymptomsList" :key="'breastCancerBreastList' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.armpit") }}</div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.breastCancerArmpitSymptomsList" :key="'breastCancerBreastList' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div v-html="t('factSheet.symptomsDesc')" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.investigateDiagnosisBreastCancer") }}</div>
      <div v-html="t('factSheet.investigateDiagnosisBreastCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <li>
          <span v-html="t('factSheet.mammogram') + ': '" class="font-bold"></span>
          <span v-html="t('factSheet.mammogramP')"></span>
        </li>
      </ul>
    </div>

    <div>
      <ul class="bullet-big">
        <li>
          <span v-html="t('factSheet.biopsy') + ': '" class="font-bold"></span>
          <span v-html="t('factSheet.biopsyDesc1')"></span>
        </li>
      </ul>
      <div v-html="t('factSheet.biopsyDesc2')" class="mt-12" />
    </div>

    <div>
      <ul class="bullet-big">
        <li>
          <span v-html="t('factSheet.hormonalReceptorHer2') + ': '" class="font-bold"></span>
          <span v-html="t('factSheet.hormonalReceptorHer2P')"></span>
        </li>
      </ul>
    </div>

    <div>
      <ul class="bullet-big">
        <li>
          <span v-html="t('factSheet.bloodTests') + ': '" class="font-bold"></span>
          <span v-html="t('factSheet.bloodTestsP')"></span>
        </li>
      </ul>
    </div>

    <div>
      <ul class="bullet-big">
        <li>
          <span v-html="t('factSheet.chestXRay')" class="font-bold"></span>
        </li>
      </ul>
    </div>

    <div>
      <ul class="bullet-big">
        <li>
          <span v-html="t('factSheet.ctPetScan') + ': '" class="font-bold"></span>
          <span v-html="t('factSheet.ctPetScanP')"></span>
        </li>
      </ul>
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.treatmentsForBreastCancer") }}</div>
      <div v-html="t('factSheet.treatmentsForBreastCancerDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.twoMainTypeOfSurgry") }}</div>
      <ol class="space-y-5">
        <template v-for="(item, index) in factSheetStore.breastCancerSurgeryTypeList" :key="'breastCancerSurgeryTypeList' + index">
          <li v-html="t(item.label)" />
        </template>
      </ol>
    </div>

    <div v-html="t('factSheet.mainTypeOfSurgeryDesc')" class="space-y-12" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.raidotherapy") }}</div>
      <div v-html="t('factSheet.raidotherapyDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.chemtherapy") }}</div>
      <div v-html="t('factSheet.chemtherapyDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.targetedTherapy") }}</div>
      <div v-html="t('factSheet.targetedTherapyDesc')" class="space-y-5" />
      <div v-html="t('factSheet.targetedTherapyDescRef')" class="mt-5" />
    </div>

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.breastCancer") }}</div>
      </div>

      <div v-html="t('factSheetChinese.breastCancerDesc')" class="space-y-12" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.whoHaveHigherChangeOfHavingBreastCancer") }}</div>
        <div v-html="t('factSheetChinese.highRiskFactors')" class="mb-5" />
        <ul class="space-y-5 bullet-big">
          <template v-for="(item, index) in factSheetStore.breastCancerHighRiskFactorsList" :key="'breastCancerHighRiskFactors' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.causeOfBreastCancer") }}</div>
        <div v-html="t('factSheetChinese.causeOfBreastCancerDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.symptomsOfBreastCancer") }}</div>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.breast") }}</div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.breastCancerBreastSymptomsList" :key="'breastCancerBreastList' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.nipple") }}</div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.breastCancerNippleSymptomsList" :key="'breastCancerBreastList' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.armpit") }}</div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.breastCancerArmpitSymptomsList" :key="'breastCancerBreastList' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div v-html="t('factSheetChinese.symptomsDesc')" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.investigateDiagnosisBreastCancer") }}</div>
        <div v-html="t('factSheetChinese.investigateDiagnosisBreastCancerDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.biopsy") }}</div>
        <ul class="bullet-big">
          <li v-html="t('factSheetChinese.biopsyP1')" />
          <li v-html="t('factSheetChinese.biopsyP2')" />
        </ul>
      </div>

      <div v-html="t('factSheetChinese.biopsyDesc')" />

      <div>
        <ul class="bullet-big">
          <li>
            <span v-html="t('factSheetChinese.mammogram') + ': '" class="font-bold"></span>
            <span v-html="t('factSheetChinese.mammogramP')"></span>
          </li>
        </ul>
      </div>

      <div>
        <ul class="bullet-big">
          <li>
            <span v-html="t('factSheetChinese.hormonalReceptorHer2') + ': '" class="font-bold"></span>
            <span v-html="t('factSheetChinese.hormonalReceptorHer2P')"></span>
          </li>
        </ul>
      </div>

      <div>
        <ul class="bullet-big">
          <li>
            <span v-html="t('factSheetChinese.bloodTests') + ': '" class="font-bold"></span>
            <span v-html="t('factSheetChinese.bloodTestsP')"></span>
          </li>
        </ul>
      </div>

      <div>
        <ul class="bullet-big">
          <li>
            <span v-html="t('factSheetChinese.chestXRay')" class="font-bold"></span>
          </li>
        </ul>
      </div>

      <div>
        <ul class="bullet-big">
          <li>
            <span v-html="t('factSheetChinese.ctPetScan') + ': '" class="font-bold"></span>
            <span v-html="t('factSheetChinese.ctPetScanP')"></span>
          </li>
        </ul>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.treatmentsForBreastCancer") }}</div>
        <div v-html="t('factSheetChinese.treatmentsForBreastCancerDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.twoMainTypeOfSurgry") }}</div>
        <ol class="space-y-5">
          <template v-for="(item, index) in factSheetStore.breastCancerSurgeryTypeList" :key="'breastCancerSurgeryTypeList' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ol>
      </div>

      <div v-html="t('factSheetChinese.mainTypeOfSurgeryDesc')" class="space-y-5" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.raidotherapy") }}</div>
        <div v-html="t('factSheetChinese.raidotherapyDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.chemtherapy") }}</div>
        <div v-html="t('factSheetChinese.chemtherapyDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.hormoneTherapy") }}</div>
        <div v-html="t('factSheetChinese.hormoneTherapyDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.targetedTherapy") }}</div>
        <div v-html="t('factSheetChinese.targetedTherapyDesc')" class="space-y-5" />
        <div v-html="t('factSheetChinese.targetedTherapyDescRef')" class="mt-5" />
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>